import { createAsyncThunk } from '@reduxjs/toolkit';
import { dataFieldsService, DataFieldsService } from 'src/services';

export const dataFieldAutoSuggestionActions = {
  getValues: createAsyncThunk(
    'DataFieldAutoSuggestion/GetDataFieldValues',
    async (
      {
        shopId,
        searchTerm,
        primaryDataField,
        additionalDataFields,
        limit,
        after,
      }: Parameters<DataFieldsService['searchFeedDataFieldValues']>[0],
      { rejectWithValue }
    ) => {
      try {
        const dataFieldValues = await dataFieldsService.searchFeedDataFieldValues({
          shopId,
          primaryDataField,
          additionalDataFields,
          searchTerm,
          limit,
          after,
        });

        return dataFieldValues;
      } catch (error) {
        return rejectWithValue({ error });
      }
    }
  ),
};
